import { defaultDateTime, timestamp } from "../app/utility";
import { env } from "../env";

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { token },
      } = store.getState();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.device_tz_offset = timestamp.timestamp;
        config.headers.device_tz_timestamp = timestamp.timezone;
      } else {
        config.headers.device_tz_offset = timestamp.timestamp;
        config.headers.device_tz_timestamp = timestamp.timezone;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { config, response } = error;

      const {
        auth: { token, user },
      } = store.getState();

      if (response.status === 401) {
        // Token expired, attempt to refresh the token
        localStorage.clear();
        window.location.reload();
      }

      if (response.status === 500 && env.NODE_ENV !== "development") {
        const payload = {
          app_type: "web",
          app_version: "1",
          os: "Windows",
          device_model: "web",
          os_version: "1",
          crash_date: defaultDateTime,
          crash_details: JSON.stringify(response.data),
          auth_token: token,
          crash_summary: "WEB crashed response API ",
          user_id: user.data.user_id,
          request_payload: JSON.stringify(config, null, 2),
        };
        try {
          const result = await axios.post(
            `${env.REACT_APP_API_URL}/api/crash-report/send`,
            payload
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  );
}
